import { createBaseQuery } from '../helper/createBaseQuery'
import { tokenSlice } from '../slice/tokenSlice'
import { validateQueryStringParameters } from '../../helpers/api'
import { identity } from 'lodash'

const bidsApi = tokenSlice.injectEndpoints({
  reducerPath: 'bidsApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['BIDs'],
  endpoints(builder) {
    return {
      getBIDs: builder.query({
        query: (params) => {
          return {
            url: `Bid/GetAll`,
            method: `GET`,
            params: validateQueryStringParameters(params),
          }
        },
        providesTags: ['BIDs'],
      }),

      getBIDsById: builder.query({
        query: (id) => {
          return {
            url: `Bid/GetCard/${id}`,
            method: `GET`,
          }
        },
        providesTags: ['BIDs'],
      }),

      getBIDsRFQList: builder.query({
        query: (businessUnitId) => {
          return {
            url: `Bid/GetRFQList/${businessUnitId}`,
            method: `GET`,
          }
        },
        providesTags: ['BIDs'],
      }),

      postBIDs: builder.mutation({
        query: (data) => {
          return {
            url: `Bid`,
            method: `POST`,
            body: data,
          }
        },
        invalidatesTags: ['BIDs'],
      }),

      deleteBIDs: builder.mutation({
        query: (bidMainId) => {
          return {
            url: `Bid`,
            method: `DELETE`,
            params: {bidMainId},
          }
        },
        invalidatesTags: ['BIDs'],
      }),

      getBIDsAttachments: builder.query({
        query: (params) => {
          return {
            url: `Attachment/GetBidAttachments`,
            params: validateQueryStringParameters(params),
          }
        },

        providesTags: ['BIDs'],
      }),

    //   getComparisonAttachments: builder.query({
    //     query: (sourceId) => ({
    //         url: `Attachment/GetBidComparisonAttachments?sourceId=${sourceId}`,
    //         method: "GET",
    //     }),
    //     providesTags: ["Attachment"],
    // }),
      
    }
  },
})

export const {
  useGetBIDsQuery,
  useGetBIDsByIdQuery,
  useDeleteBIDsMutation,
  usePostBIDsMutation,
  useGetBIDsRFQListQuery,
  useGetBIDsAttachmentsQuery,
} = bidsApi
export { bidsApi }
